var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfStudy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5860",
    "data-name": "Group 5860",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.214,
    height: 150,
    viewBox: "0 0 135.214 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1454",
    "data-name": "Rectangle 1454",
    width: 135.214,
    height: 150,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5867",
    "data-name": "Group 5867",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5864",
    "data-name": "Group 5864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5863",
    "data-name": "Group 5863",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5862",
    "data-name": "Group 5862",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5861",
    "data-name": "Group 5861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5860-2",
    "data-name": "Group 5860",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4606",
    "data-name": "Path 4606",
    d: "M105.869,40.292c13.809,17.013,28.17,30.38,29.275,44.962,1.1,14.472-11.047,30.159-24.967,42.532-13.809,12.483-29.5,21.763-45.4,22.2-16.018.332-32.257-8.285-44.188-20.768A74.8,74.8,0,0,1,.148,82.934C-.957,65.48,4.124,46.81,15.945,29.908,27.765,12.9,46.435-2.35,62.454.3c16.128,2.541,29.5,23.089,43.415,39.991",
    fill: "#0af"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4607",
    "data-name": "Path 4607",
    d: "M30.951,104.688l-2.509,3.484H41.125v-3.484Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4608",
    "data-name": "Path 4608",
    d: "M43.912,115l4.181-2.091L52.274,115V104.686H43.912Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5866",
    "data-name": "Group 5866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5865",
    "data-name": "Group 5865",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4609",
    "data-name": "Path 4609",
    d: "M47.953,96.045,34.991,98.972,32.9,101.9h29.13a1.393,1.393,0,0,1,0,2.787H55.062v3.485h4.181a1.5,1.5,0,0,1,1.394,1.393,1.5,1.5,0,0,0,1.394,1.394h4.181v-9.9a20.266,20.266,0,0,0-18.257-5.017Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4610",
    "data-name": "Path 4610",
    d: "M104.26,104.688H73.18a1.394,1.394,0,0,1,0-2.787h29.13l-2.09-2.927L87.258,96.047A20.769,20.769,0,0,0,69,101.064v9.9h4.181a1.5,1.5,0,0,0,1.394-1.394,1.5,1.5,0,0,1,1.393-1.394h30.8Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4611",
    "data-name": "Path 4611",
    d: "M87.816,93.258l6.272,1.393V84.2A18.239,18.239,0,0,0,77.363,65.941v1.254a9.757,9.757,0,1,1-19.513,0V65.941A18.239,18.239,0,0,0,41.126,84.2V94.651L47.4,93.258a23.092,23.092,0,0,1,20.21,5.3,23.092,23.092,0,0,1,20.21-5.3ZM54.226,72.213a12.306,12.306,0,0,0-7.248,9.059,1.246,1.246,0,0,1-1.393,1.115c-1.394-.139-1.533-.836-1.394-1.672A14.937,14.937,0,0,1,53.111,69.7a1.373,1.373,0,1,1,1.115,2.509M77.362,83.781a1.5,1.5,0,0,1,1.394-1.394h11.15a1.394,1.394,0,0,1,0,2.788H78.756a1.4,1.4,0,0,1-1.394-1.394",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4612",
    "data-name": "Path 4612",
    d: "M60.637,67.753a6.889,6.889,0,0,0,6.969,6.411,6.992,6.992,0,0,0,6.968-6.411s-1.393,3.484-6.968,3.484a8.41,8.41,0,0,1-6.969-3.484",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4613",
    "data-name": "Path 4613",
    d: "M62.448,42.387a1.477,1.477,0,0,1,1.812.418c1.394,2.091,4.32,3.345,7.665,3.345,3.206,0,6.133-1.254,7.527-3.066A12.579,12.579,0,0,0,67.744,35a12.425,12.425,0,0,0-11.707,8.223,12.415,12.415,0,0,0,6.411-.836",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4614",
    "data-name": "Path 4614",
    d: "M63.843,66.917a5.57,5.57,0,0,0,7.526,0l5.157-5.157a12.218,12.218,0,0,0,3.624-8.78V46.15a13.692,13.692,0,0,1-8.363,2.788,12.589,12.589,0,0,1-9.2-3.624c-1.394.557-5.715,1.254-7.387.557,0,.558-.14,7.109-.14,7.109a12.218,12.218,0,0,0,3.624,8.78Z",
    fill: "#2b528e"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfStudy);
export default __webpack_public_path__ + "static/media/self-study.98f1030385ce541ab96d8fd69f5d28ea.svg";
export { ForwardRef as ReactComponent };